<template>
  <section
    :class="['customizer-new-header', { 'is-apac': regionIsApac }, { 'customizer-new-header-canvas': canvasActiveTablet }]"
  >
    <div :class="['customizer-new-header__container-logo-model-name', { 'hide': canvasActiveMobile || canvasActiveTablet }]">
      <button
        :class="['customizer-new-header__logo', this.themeLogo]"
        @click="changeExternalHeadersVisibility()"
        aria-label="Vans Customs Logo"
        v-if="showCustomizerHeaderLogo"
      >
        <img :src="this.logoImage" alt="Vans Customs Logo" />
      </button>
      <h1 
        :class="['customizer-new-header__model-name', themeHeaderModelName]"
      >
        {{pdm.product_name}}
      </h1>
      <a :href="configuration?.cartPath" class="customizer-new-header__shopping-cart" v-if="configuration.enableAddToCartIcon && isMobile && itemsInCart >= 0">
        <img alt="shopping cart icon" :aria-hidden="true"
          :src="customsAssets + '/svg/customizer/icon-shopping-cart.svg'"
        />
        <div>{{ itemsInCart }}</div>
      </a>
    </div>

    <div :style="{width: maxWidth + 'px'}"
      v-if="!isMobile && configuration.enableCollapsableHeader"
      :class="['customizer-new-header__container-other-buttons', themeHeaderOptions]"
      aria-label="Primary navigation menu"
    >
      <ul v-for="(item, index) in desktopHeaderItems" :key="item.name"
          :class="[
            'customizer-header-right-options-option--' + item.name,
            { 'show-button-animation': item.name === 'finishMyDesign' },
            'customizer-new-header__option-button', {
            'customizer-new-header__option-button--disabled': rayTracerDisabled || item.disabled,
            'customizer-new-header__option-button--first': index === 0,
          }]" 
          :aria-hidden="!item.display"
          @click="() => openModal(desktopHeaderItems[index])">
            <li class="outer-wrapper" :style="item.display ? 'display:block' : 'display: none'">
              <button class="inner-wrapper">
                <span class="customizer-new-header__option-name">
                  {{ translations[item.keyTranslate] }}
                </span>
                <div v-if="configuration.enableCustomizerHeaderIcons !== false" class="customizer-new-header__option-icon">
                  <span v-if="item.icon" :class="item.icon"></span>
                  <img
                    v-else-if="customsAssets && item.url"
                    :src="customsAssets + '/' + item.url"
                  />
                </div>
              </button>
            </li>
        </ul>
    </div>

    <button v-if="!isMobile && configuration.enableCollapsableHeader && customOptions.length >= numDisplayedOptions" @click="openCollapsingHeader" 
      class="collapse-header"
      :aria-label="openHeader ? translations.groupShareClose : 'More actions'" 
      :aria-expanded="openHeader"
      @focus="resetTabIndexHeader"
    >
      <span :style="!openHeader ? 'display:block' : 'display: none'" class="icon-three-dots"></span>
      <span :style="openHeader ? 'display:block' : 'display: none'" class="icon-close"></span>
    </button>

    <div
      v-if="isMobile || !configuration.enableCollapsableHeader"
      :class="[
        'customizer-new-header__container-other-buttons',
        { 'is-apac': regionIsApac },
        themeHeaderOptions
      ]"
    >
      <swiper
        :options="swiperOptions"
        @click-slide="(index, reallyIndex) => openModal(customOptions[index])"
        ref="swiper"
        @hook:updated="onSwiperUpdated"
      >
        <swiper-slide
          v-for="(item, index) in customOptions" :key="item.name"
          :class="[
            'customizer-header-right-options-option--' + item.name,
            { 'show-button-animation': item.name === 'finishMyDesign' },
            'customizer-new-header__option-button', {
            'customizer-new-header__option-button--disabled': rayTracerDisabled || item.disabled,
            'customizer-new-header__option-button--first': index === 0,
          }]"
        >
            <div class="outer-wrapper">
              <div class="inner-wrapper">
                <span class="customizer-new-header__option-name">
                  {{ translations[item.keyTranslate] }}
                </span>
                <div v-if="configuration.enableCustomizerHeaderIcons !== false" class="customizer-new-header__option-icon">
                  <span v-if="item.icon" :class="item.icon"></span>
                  <img
                    v-else-if="customsAssets && item.url"
                    :src="customsAssets + '/' + item.url"
                  />
                </div>
              </div>
            </div>
        </swiper-slide>
      </swiper>
    </div>
    <div v-show="this.enableBuyPanel && !this.isMobile"
      :class="[
        'customizer-new-header__container-buy-button',
        'customizer-new-header__container-buy-button--desktop',
        {
          'customizer-new-header__container-buy-button--disabled': rayTracerDisabled,
          'splash-desktop-modal-open-control': isSplashModalOpen && !isMobile && screenOrientation === 'landscape',
        },
        themeBuyButton
      ]"
      :style="themeBuyButtonStyle"
    >
      <buy-button-label class="customizer-new-header__buy-button"></buy-button-label>
    </div>
    <template v-if="this.enableStartOver">
      <new-modal-wrapper v-if="configuration.enableNewStartOverModal && !configuration.modals.startOver"
        :widthModal="'90%'"
        :maxWidthModal="500"
        modal-name="newStartOverModal"
        title="startOverHeader"
        cta-secondary-button="startOverNo"
        cta-primary-button="startOverAccept"
        @cta-action="$refs.content.ctaAction()" >
        <start-over-component ref=content ></start-over-component>
      </new-modal-wrapper>
      <start-over-modal v-else />
    </template>

    <template v-if="this.enableFavorites">
      <new-modal-wrapper v-if="configuration.enableNewFavoritesModal && !configuration.modals.favorites"
        :widthModal="'90%'"
        :maxWidthModal="500"
        modal-name="newFavoritesModal"
        title="favoritesTitle" >
        <template v-slot="{contentProps}">
          <favorites-component :contentProps="contentProps" ></favorites-component>
        </template>
      </new-modal-wrapper>
      <favorite-modal v-else />
    </template>


    <template v-if="this.enableShare">
      <share-your-design-modal
        v-if="!configuration.modals.shareYourDesign"
        :enable-check="forceShareYourDesignCheck"
      ></share-your-design-modal>
      <share-your-design v-else :enable-check="forceShareYourDesignCheck"/>
    </template>

    <new-modal-wrapper v-if="configuration.enableNewProductMissingModal"
      :widthModal="'90%'"
      :maxWidthModal="500"
      modal-name="productMissingModal"
      cta-primary-button="productMissingCta"
      @cta-action="$modal.hide('productMissingModal')"
    >
      <product-missing-modal ></product-missing-modal>
    </new-modal-wrapper>
    <modal-wrapper v-else
      modal-name="productMissingModal"
      title="productMissingHeader"
      content-component="productMissingModal"
      cta-button="defaultRecipeContinueCustomizing"
    ></modal-wrapper>

    <new-modal-wrapper
      :widthModal="'90%'"
      :maxWidthModal="500"
      modal-name="genericErrorModal"
      cta-primary-button="passcodeContinue"
      @cta-action="$modal.hide('genericErrorModal')"
    >
      <generic-error-modal></generic-error-modal>
    </new-modal-wrapper>

    <transition v-if="tmallEnabled" name="fade">
      <tmall-wishlist-notification v-show="showTmallWishlistNotification" :favoriteSaved="tmallWishlistSaved"></tmall-wishlist-notification>
    </transition>
    <template v-if="enableTransferDesign">
      <transfer-design-modal v-if="configuration.modals.transferDesign" ></transfer-design-modal>
      <transfer-design-component v-else ></transfer-design-component>
    </template>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import buyButtonLabel from '@/components/Customizer/CustomizerHeader/BuyButtonLabel';
import shareYourDesignModal from '@/components/Modals/ShareYourDesign';
import shareYourDesign from '@/components/organism.modal.shareYourDesign.vue';
import modalWrapper from '@/components/Modals/ModalWrapper';
import newModalWrapper from '@/components/Modals/NewModalWrapper';
import startOverComponent from '@/components/Modals/StartOver';
import favoritesComponent from '@/components/Modals/Favorites';
import favoriteModal from '@/components/organism.modal.favorite.vue';
import startOverModal from '@/components/organism.modal.startOver.vue';
import productMissingModal from '@/components/Modals/ProductMissing';
import genericErrorModal from '@/components/Modals/GenericError';
import tmallWishlistNotification from '@/components/Customizer/CustomizerHeader/TmallWishlistNotification';
import transferDesignComponent from '@/components/Customizer/TransferDesignModal';
import transferDesignModal from '@/components/organism.modal.transferDesign.vue';
import { themePalette } from '@/data/constants';
import { options } from "@/components/Customizer/CustomizerHeader/headerOptions";
import { getLocale } from "@/data/regionInfo";
import getScreenOrientation from '@/libs/screenOrientation';
import selectSwatch from '@/mixins/Customizer/SelectSwatch';
import { getSafeRedirectUrl, navigateToSafeRedirectUrl } from "@/utils/customizerMessagingSecurity";

let isheaderButtonAnimation = false;
const numberOfDisplayedOptions = {
  medium: 3,
  large: 4
};

export default {
  name: "customizerNewHeader",
  components: {
    Swiper,
    SwiperSlide,
    buyButtonLabel,
    shareYourDesignModal,
    shareYourDesign,
    modalWrapper,
    newModalWrapper,
    startOverComponent,
    favoritesComponent,
    favoriteModal,
    startOverModal,
    productMissingModal,
    genericErrorModal,
    transferDesignComponent,
    transferDesignModal,
    tmallWishlistNotification
  },
  mixins: [
    selectSwatch
  ],
  props: {
    enableShare: {
      type: Boolean,
      default: true
    },
    enableRandomize: {
      type: Boolean,
      default: true
    },
    enableUndo: {
      type: Boolean,
      default: true
    },
    enableStartOver: {
      type: Boolean,
      default: true
    },
    enableFavorites: {
      type: Boolean,
      default: true
    },
    enableTransferDesign: {
      type: Boolean,
      default: true
    },
    enableSplashPage: {
      type: Boolean,
      default: true
    },
    enableBuyPanel: {
      type: Boolean,
      default: true
    },
    enableFinishMyDesign: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      options,
      swiperOptions: {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
      },
      screenOrientation: null,
      showTmallWishlistNotification: false,
      tmallWishlistSaved: false,
      openHeader: false,
      maxWidth: 0,
    };
  },
  computed: {
    itemsInCart() {
      return this.$store.state.utils.queryParams.totalItems;
    },
    swiper() {
      return this.$refs?.swiper?.$swiper;
    },
    screenSize() {
      return this.$store.getters["utils/returnScreenSize"];
    },
    numDisplayedOptions() {
      if (this.screenSize === "medium") return numberOfDisplayedOptions.medium;
      return numberOfDisplayedOptions.large;
    },
    isMobile() {
      return this.screenSize.includes('mobile');
    },
    isTablet() {
      return this.screenSize.includes('medium');
    },
    isSplashModalOpen() {
      return this.$store.state.utils.isSplashModalOpen;
    },
    translations(){
      return this.$store.state.translations.data;
    },
    tmallEnabled() {
      return this.$store.getters['utils/tmallEnabled'];
    },
    pdm() {
      if (this.$store.state.utils.pdm) {
        return this.$store.state.utils.pdm;
      }
      return "";
    },
    queryParams() {
      return this.$store.state.utils.queryParams;
    },
    desktopHeaderItems() {
      return this.customOptions.map((element, index) => {
          if(index >= this.numDisplayedOptions){
            element.display = this.openHeader;
          } else {
            element.display = true;
          }
          return element;
        });
    },
    customOptions() {
      let customOptions = [];
      // checks if the feature is enabled in the props
      for (let item of this.options) {
        if (!!this[item.flag]) {
          if (item.name === 'transferStyle') {
            // if any of these conditions are matched, it doesn't
            // include the transferDesign to the header
            if (!this.$store.state.utils.isSplashModalOpen
              && (this.$store.state.recipe.defaultRecipe.components && !this.isTransferDesignEnabledByFeatureFlag())
              || !this.configuration.changeStyle.models_enabled.includes(this.$store.state.utils.pdmModel)
            ) {
              continue;
            }
          }

          if (item.name === 'undo' ) {
            if(this.isUndoConfigDisabled){
              continue;
            }else if (!this.hasUndoChanges) {
              item = { ...item, disabled: true };
            }
          }

          if (item.name === 'finishMyDesign') {
            if (this.disableFinishMyDesign) {
              isheaderButtonAnimation = false;
              continue;
            } else {
              isheaderButtonAnimation = true;
            }
          }

          if(item.name == 'splashPage') item.disabled = this.isSplashModalOpen;

          customOptions.push(item);
        }
      }
      return customOptions;
    },
    locale() {
      return this.$store.state.utils.configuration.locale;
    },
    forceShareYourDesignCheck() {
      return this.$store.state.utils.configuration.forceShareYourDesignCheck;
    },
    customsAssets() {
      return this.$store.state.endPoints.customizer.customsAssets;
    },
    rayTracerDisabled() {
      return this.$store.state.utils.trayDisabled.swatches || this.$store.state.utils.trayDisabled.geostates;
    },
    regionIsApac() {
      return this.$store.getters['utils/regionIsApac'];
    },
    noEsiActive() {
      return this.$store.getters['utils/noEsiActive'];
    },
    vsfActive() {
      return this.$store.getters['utils/vsfActive'];
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    paletteTheme() {
      return this.$store.state.swatches.paletteTheme;
    },
    themeBuyButton() {
      const buy_button_class = this.paletteTheme && this.paletteTheme.palette_features && this.paletteTheme.palette_features.buy_button_class;
      return buy_button_class ? `${themePalette.themePrefix}${buy_button_class}` : false;
    },
    themeLogo() {
      const theme_logo_class = this.paletteTheme && this.paletteTheme.palette_features && this.paletteTheme.palette_features.logo_class;
      return theme_logo_class ? `${themePalette.themePrefix}${theme_logo_class}` : false;
    },
    themeBuyButtonStyle() {
      if (this.themeBuyButton) {
        return {
          "background-image": `url(${this.customsAssets}/images/customizer/themes/${this.paletteTheme.tab_id}/${this.paletteTheme.palette_features.buy_button_src})`
        };
      }
      return false;
    },
    logoImage() {
      if(this.themeLogo) {
        return `${this.customsAssets}/images/customizer/themes/${this.paletteTheme.tab_id}/${this.paletteTheme.palette_features.logo_src}`;
      }
      return `${this.customsAssets}/images/common/customs_logo_red.png`;
    },
    themeHeaderModelName() {
      const header_model_name_class = this.paletteTheme && this.paletteTheme.palette_features && this.paletteTheme.palette_features.header_model_name_class;
      return header_model_name_class ? `${themePalette.themePrefix}${header_model_name_class}` : false;
    },
    themeHeaderOptions() {
      const header_options_class = this.paletteTheme && this.paletteTheme.palette_features && this.paletteTheme.palette_features.header_options_class;
      return header_options_class ? `${themePalette.themePrefix}${header_options_class}` : false;
    },
    hasUndoChanges() {
      return this.$store.state.undo.previousSwatch.length > 0 || Object.keys(this.$store.state.undo.previousRecipe).length > 0;
    },
    isUndoConfigDisabled(){
      return this.configuration.undo.turn_off_all_models || !this.configuration.undo.models_enabled.includes(this.pdm.sku);
    },
    disableFinishMyDesign() {
      return this.$store.state.utils.isFinishMyDesignApplied ||
            this.validateRecipesFinishMyDesign ||
            !this.recipeContainsDefaultSwatches ||
            this.$recipe.existPersonalizationWithDefaultRecipe();
    },
    recipeContainsDefaultSwatches() {
      const { recipe_v2, defaultRecipe } = this.$store.state.recipe;
      if (Object.keys(recipe_v2).length === 0 || Object.keys(defaultRecipe).length === 0) return true;
      const checkRecipeMatches = Object.keys(recipe_v2?.components)
        .filter(component => recipe_v2.components[component]?.swatch_id === defaultRecipe.components[component]?.swatch_id);
      return checkRecipeMatches.length > 0;
    },
    validateRecipesFinishMyDesign() {
      const { recipe_v2, initRecipe} = this.$store.state.recipe;
      return JSON.stringify(initRecipe.components) === JSON.stringify(recipe_v2.components);
    },
    canvasActive() {
      return this.$store.getters["utils/canvasActive"];
    },
    canvasActiveTablet() {
      return this.$store.getters["utils/canvasActive"] && this.isTablet;
    },
    canvasActiveMobile() {
      return this.$store.getters["utils/canvasActive"] && this.isMobile;
    },
    showCustomizerHeaderLogo() {
      return this.configuration.showCustomizerHeaderLogo;
    }
  },
  watch: {
    // Disables swiping when splash page is open
    isSplashModalOpen(newVal) {
      if (this.swiper && this.isMobile) this.swiper.allowTouchMove = !newVal;
    }
  },
  methods: {
    /**
     * Hides Splash Page on click (Desktop Only)
     * @see onBackgroundClick() - SplashPage.vue
     */
    hideSplashPage(){
      if (this.enableSplashPage && this.isSplashModalOpen && !this.isMobile)
        this.$eventBus.$emit("splash-page-background-click");
    },
    /**
     * @function isTransferDesignEnabledByFeatureFlag
     * This method evaluates if the transfer design button should be enabled
     * using the feature flag from configuration.json
     */
    isTransferDesignEnabledByFeatureFlag() {
      const { transferDesign } = this.configuration;
      if (!transferDesign.embroidery && this.$recipe.checkForPersonalization()) {
        return false;
      }
      if (!transferDesign.patternMaker && this.$recipe.checkUGCByType({ includePatternMaker: true })) {
        return false;
      }
      if (!transferDesign.customCheckerboard && this.$recipe.checkUGCByType({ includeCustomCheckerboard: true })) {
        return false;
      }
      if (!transferDesign.ugc && this.$recipe.checkUGCByType({ customUGC: true })) {
        return false;
      }
      return true;
    },
    /**
     * @function changeExternalHeadersVisibility
     *
     * Show or hide WCS headers
     * param: - state - 'show' or 'hide'
     */
    changeExternalHeadersVisibility(state) {
      if (this.regionIsApac || this.tmallEnabled) {
        return;
      }

      let visible;
      if (state === 'show') {
        visible = true;
      } else if (state === 'hide') {
        visible = false;
      } else {
        visible = !this.$store.state.utils.externalHeadersVisible;
      }

      this.vsfActive && this.$eventBus.$emit('customsToggleHeader', { visible });
      this.$eventBus.$emit('changeGlobalFocusState', { visible: !visible });

      this.$store.getters["utils/canvasActive"] && this.$iframeCommunicator.postMessage({ command: 'toggleHeader', body: { visible } });

      this.$store.commit('utils/CHANGE_VISIBILITY_EXTERNAL_HEADERS', visible);
    },
    setDataLayer(eventLabel, forceEcomDataLayerFormat) {
      if (this.$store.getters['utils/useEcomDataLayerFormat'] || forceEcomDataLayerFormat) {
        this.$customizerDataLayer.logAnalyticsEvent({ type: this.$customizerDataLayer.types.customizerTopHeader, eventLabel, forceEcomDataLayerFormat });
      }
    },
    openModal(obj) {
      if ((obj?.disabled) || this.rayTracerDisabled)
        return;

      // If Splash Page is open we need to prevent clicks on menu items
      if (this.enableSplashPage && this.isSplashModalOpen) {
        this.hideSplashPage();
        return;
      }
      let eventLabel = "Start Over";
      let forceEcomDataLayerFormat = false;

      if (obj.name === "startOver") {
        const recipeId = this.queryParams.recipe || this.pdm.default_recipe;
        const modalName = this.configuration.modals.startOver ? 'startOverModal' : 'newStartOverModal';
        this.$modal.show(modalName, { recipeId });
      } else if (obj.name === "share") {
        const { mainSiteUrls, sharingButtonUrl } = this.$store.state.endPoints.customizer;
        const { env } = this.$store.state.utils;
        eventLabel = "Share";
        if (this.$store.state.utils.configuration.sharingButtonBehavior &&
          !!sharingButtonUrl &&
          !!mainSiteUrls &&
          mainSiteUrls[env]) {

          obj.disabled = true;
          this.$store.dispatch("recipe/SAVE_RECIPE", { recipe: this.$store.state.recipe.recipe_v2, requestParams: { locale: getLocale() } })
            .then(({ recipeId }) => {
              // Clear onbeforeunload event
              this.$eventBus.$emit("set-onbeforeunload");

              window.location.href = `${ mainSiteUrls[env] }${ sharingButtonUrl }?recipe=${ recipeId }`;
            })
            .catch(err => {
              console.error('openModal error: ', err);
              obj.disabled = false;
            });
        } else {
          const modalName = this.configuration.modals.shareYourDesign ? 'shareYourDesign' : 'shareYourDesignModal';
          this.$modal.show(modalName);
        }
      } else if (obj.name === "favorite") {
        if(this.tmallEnabled) {
          this.openTmallFavorite();
        } else {
          obj.disabled = true;
          eventLabel = "Favorite";
          this.$store.commit('utils/SET_TRAY_DISABLED_STATUS', { element: 'geostates', status: true });
          this.getFavoritesData(obj).then(() => obj.disabled = false);
        }
      } else if (obj.name === 'transferStyle') {
        eventLabel = 'Change Style';
        forceEcomDataLayerFormat = true;
        this.$modal.show(this.configuration.modals.transferDesign ? "transferDesignModal": "transferDesignComponent");
      } else if (obj.name === 'splashPage') {
        this.$store.commit('utils/SET_IS_SPLASH_MODAL_OPEN', true);
        this.$modal.show('splashPageModal');
        eventLabel = 'Help';
        forceEcomDataLayerFormat = true;
      } else if (obj.name === "undo") {
        eventLabel = 'Undo';
        forceEcomDataLayerFormat = true;
        this.undo();
      } else if (obj.name === "finishMyDesign") {
        this.$store.commit(
          'undo/UPDATE_PREVIOUS_RECIPE',
          { recipe: this.$store.state.recipe.recipe_v2 },
        );
        eventLabel = 'Finish My Design';
        forceEcomDataLayerFormat = true;
        this.$store.commit('utils/SET_IS_FINISH_MY_DESIGN_APPLIED', true);
        this.$store.commit("finishMyDesign/SET_LOADING_FINISH_MY_DESIGN", { status: true });
        this.finishMyDesign();
      } else if (obj.name === 'randomize') {
        eventLabel = "Randomize";
        forceEcomDataLayerFormat = true;
        this.onRandomizeClick();
      }

      this.setDataLayer(eventLabel, forceEcomDataLayerFormat);
    },
    getFavoritesData() {
      let recipeId,model;
      let itemToPurchase = this.$store.state.buyPanel.itemsToPurchase[0];

      return new Promise((resolve, reject) => {
        this.$store.dispatch("recipe/SAVE_RECIPE", {
          recipe: this.$store.state.recipe.recipe_v2,
          requestParams: { locale: getLocale() }
        }).then((data) => {
          recipeId = data.recipeId;
          model = this.$store.state.recipe.recipe_v2.pdm;
          this.$store.dispatch("buyPanel/GET_SKU", {
            recipe_id: recipeId,
            locale: getLocale(),
            size: itemToPurchase.size
          }).then(data => {
            const product = {
              extRecipeId: recipeId,
              partNumber: data.sku,
              quantity: itemToPurchase.quantity,
              model
            }
            this.tmallEnabled ?  this.tmallAddFavorite(product) : this.addToFavorites(product);
            resolve();
          }).catch(err => {
            console.error("Error getting sku:", err);
            this.handleFavoritesError();
            reject(err);
          });
        }).catch(err => {
          console.error("Error getting recipe id:", err);
          this.handleFavoritesError();
          reject(err);
        })}
      );
    },
    addToFavorites(product) {
      const ImageView2D = this.$store.state.utils.pdm.product_images.featured_views.mini_cart_lg
        || this.$store.state.utils.pdm.product_images.featured_views.mini_cart;
      const addToFavoritesEventObject = {
        recipe: product.extRecipeId,
        sku: product.partNumber,
        '2dImageView': ImageView2D
      };

      if (this.$store.getters["utils/canvasActive"]) {
        this.callFavoritesAPI({product}).then((response)=>{
          this.handleFavorites({ body: response });
        }).catch((err)=>{
          this.handleFavoritesError();
          reject(err);
        });
      } else if (this.vsfActive) {
        this.$eventBus.$emit('customsAddToFavorites', addToFavoritesEventObject);
      } else {
        let requestData = {
          ...product,
          catalogId: this.$store.state.utils.configuration.catalogId,
          storeId: this.$store.state.utils.configuration.storeId,
          langId: this.$store.state.utils.configuration.langId,
          action: "save",
          listId: ".",
          listIdName: "listId",
          pageName: "wishlist",
          URL: "LogonForm",
        };

        const { sessionId } = this.$store.state.utils.configuration;
        const { env } = this.$store.state.utils;
        if (!!sessionId && sessionId[env]) {
          const cookieValue = sessionId[env] ? this.$cookies.get(sessionId[env]) : null;
          if (cookieValue) requestData.sessionId = cookieValue;
        }
        return new Promise((resolve, reject) => {
          this.$store.dispatch("buyPanel/ADD_TO_WISHLIST", {
            data: requestData
          }).then(response => {
            this.handleFavorites({ body: response });
            resolve();
          })
          .catch(err => {
            console.error(err);
            this.handleFavoritesError();
            reject(err);
          });
        });
      }
    },

    async callFavoritesAPI({product}){
      if(this.configuration.enableSnapshotService) {
        let productImage;
        const productImages = this.$store.state.modals.productImages.favorites;
        if (productImages[product.extRecipeId]) {
          productImage = productImages[product.extRecipeId];
        } else {
          const data = await this.initExternal3Dscene({domEl: "snapshot-image-scene", snapshotSize: "md", snapshotView: "checkerboard_creator", showSnapShot: true});
          productImage = data.fileUrl;
        }
        this.$store.commit('modals/SET_FAVORITES_PRODUCT_IMAGE', {
          recipeId: productImage.split("/")[5],
          data: productImage
        });
        return this.$store.dispatch('utils/CALL_FAVORITES_API', {
          recipe: product.extRecipeId,
          sku: product.partNumber,
          productImageURL: productImage,
          quantity: product.quantity
        })
      } else {
        return this.$store.dispatch('ugc/tempData/GET_PRODUCT_IMAGES_BY_RECIPE_ID', {
          recipe_id: product.extRecipeId,
          locale: getLocale(),
          type: 'customizer',
          featuredView: {"view": "left_square", "size": "md-square-white"}
        }).then((data)=> {
          return this.$store.dispatch('utils/CALL_FAVORITES_API', {
            recipe: product.extRecipeId,
            sku: product.partNumber,
            productImageURL: data.left_square_view["md-square-white"],
            quantity: product.quantity
          })
        })
      }
    },

    openFavoritesModal(payload){
      const modalName = this.configuration.modals.favorites ? 'favoriteModal' : 'newFavoritesModal';
      this.$modal.show(modalName, payload);
    },
    handleFavorites({ body } = {}) {
      if (!body || typeof body !== "object") {
        console.warn("CustomizerHeader - handleFavorites rejected message", { reason: "invalid-body" });
        this.handleFavoritesError();
        return;
      }

      const shouldRedirect = body.redirectUrl && body.action && body.action === 'redirect';
      const safeRedirectUrl = shouldRedirect ? getSafeRedirectUrl(body.redirectUrl) : null;

      if (shouldRedirect && !safeRedirectUrl) {
        navigateToSafeRedirectUrl(body.redirectUrl, { context: "CustomizerNewHeader.handleFavorites" });
        this.handleFavoritesError();
        return;
      }

      if (this.noEsiActive && body.status === 'error') {
        console.error('CustomizerHeader - handleFavorites: ', body.message);
        this.handleFavoritesError();
      } else if (this.vsfActive && body.status === 'error') {
        console.error('CustomizerHeader - handleFavorites: ', body.message);
        this.handleFavoritesError();
      } else {
        this.$store.commit('utils/SET_TRAY_DISABLED_STATUS', { element: 'geostates', status: false });
        this.$store.commit("recipe/SET_SAVED_RECIPE", this.$store.state.recipe.recipe_v2);

        // Clear onbeforeunload event
        this.$eventBus.$emit("set-onbeforeunload");

        if (shouldRedirect) {
          window.location.href = safeRedirectUrl;
        } else {
          this.openFavoritesModal({ favoriteSaved: true })
        }

        if (typeof($) !== "undefined" && $.pubsub) {
          $.pubsub(
            "publish",
            "vfdp.wcs.product_form.add_to_favorites_succeeded"
          );
          $.pubsub('publish','WISHLIST_UPDATED');
        }
      }
    },
    handleFavoritesError() {
      if (this.tmallEnabled) {
        this.handleShowTmallNotification(false);
      }
      else {
        this.openFavoritesModal({favoriteSaved: false, tmallEnabled: this.tmallEnabled})
      }
      this.$store.commit('utils/SET_TRAY_DISABLED_STATUS', { element: 'geostates', status: false });
    },
    onWindowResized() {
      this.screenOrientation = getScreenOrientation();
      isheaderButtonAnimation = false;

      if (this.isMobile || !this.configuration.enableCollapsableHeader) {
        this.onSwiperUpdated();
      }
    },
    tmallAddFavorite(requestData) {
      return new Promise((resolve, reject) => {
        if(typeof my !== 'undefined') {
          my.postMessage({'topic':'addToCart','action':'save','sku': requestData.partNumber, 'model': requestData.model, 'recipeId': requestData.extRecipeId,'qty': requestData.quantity});
          my.onMessage = function(message){
            const tmallModalSubTitle = `Topic: ${message.topic}`;
            const tmallModalDesc =`message.action: ${message.action}<br>message.value: ${message.value}<br>message.detail: ${message.detail}<br>messageJSON: ${JSON.stringify(message)}`;
            console.info("tmallMiniappMessagesModal", {tmallModalSubTitle,tmallModalDesc});
            const { bundle_partnumber, pdm } = this.$store.state.recipe.recipe_v2;
            //Save recipe object
            this.$store.commit("recipe/SET_INIT_RECIPE", this.$store.state.recipe.recipe_v2);
            this.$store.commit('utils/SET_TRAY_DISABLED_STATUS', { element: 'geostates', status: false });
            this.$store.commit("recipe/SET_SAVED_RECIPE", this.$store.state.recipe.recipe_v2);

            // Clear onbeforeunload event
            this.$eventBus.$emit("set-onbeforeunload");
            this.handleShowTmallNotification(true);
            resolve();
          }
        } else {
          this.$store.commit('utils/SET_TRAY_DISABLED_STATUS', { element: 'geostates', status: false });
          console.error('No miniapp my object was found');
          reject(new Error('Error on Add to Wishlist: No miniapp my object was found'));
        }
      });
    },
    handleShowTmallNotification(isSaved) {
      this.tmallWishlistSaved = false;
      this.$eventBus.$emit("tmall-wishlist-saved", isSaved);
      if (isSaved === true) {
        this.tmallWishlistSaved = true;
      }
      this.showTmallWishlistNotification = true;
      setTimeout(() => this.showTmallWishlistNotification = false, 3000);
    },
    openTmallFavorite() {
      this.$eventBus.$emit("tmall-resize-buypanel");
      this.$eventBus.$emit('show-buy-panel', false, true);
    },
    handleTmallCTASaveDesign() {
      this.$store.commit('utils/SET_TRAY_DISABLED_STATUS', { element: 'geostates', status: true });
      this.getFavoritesData();
    },
    handleSwiperWidth() {
      const { innerWidth } = window;

      if (innerWidth >= 640) {
        const logoModelNameEl = document
          .querySelector('.customizer-new-header__container-logo-model-name');
        let removalWidth = 0;

        if (innerWidth > 1023) {
          const buyDesktopEl = document
            .querySelector('.customizer-new-header__container-buy-button--desktop');

          removalWidth += buyDesktopEl ? buyDesktopEl.offsetWidth : 0;
        }

        removalWidth += logoModelNameEl ? logoModelNameEl.offsetWidth : 0;
        this.swiper.params.width = innerWidth - removalWidth;
      } else if (this.swiper.params.width) {
        delete this.swiper.params.width;
      }

      this.swiper.update();
    },
    onSwiperUpdated() {
      if (isheaderButtonAnimation || this.isSplashModalOpen) {
        setTimeout(() => this.handleSwiperWidth(), 800);
      } else {
        this.handleSwiperWidth();
      }
    },
    handleHeaderWidth() {
      const headerWidth = [...document.getElementsByClassName('customizer-new-header__option-button')]
        .slice(0, this.numDisplayedOptions).reduce((acc, domEl) => acc + domEl.offsetWidth, 0) + 50;

      if (headerWidth > this.maxWidth) {
        this.maxWidth = headerWidth;
      }
    },
    openCollapsingHeader() {
      if (this.isSplashModalOpen) {
        this.$eventBus.$emit("splash-page-background-click");
        return;
      }
      this.openHeader = !this.openHeader;
      const elementName = this.customOptions[this.numDisplayedOptions].name;
      if(this.openHeader) {
        this.customOptions.forEach((element,index) => {
          if(index>=this.numDisplayedOptions) {
            document.querySelector(`.customizer-header-right-options-option--${element.name} button`).setAttribute("tabindex",0)
          } else {
            document.querySelector(`.customizer-header-right-options-option--${element.name} button`).setAttribute("tabindex",-1)
          }
          document.querySelector(`.collapse-header`).setAttribute("tabindex",0)
          this.$nextTick(() => {
            document.querySelector(`.customizer-header-right-options-option--${elementName} button`).focus();
          })
        })
      } else {
        this.customOptions.forEach((element,index) => {
          document.querySelector(`.customizer-header-right-options-option--${element.name} button`).removeAttribute("tabindex")
        })
        document.querySelector(`.collapse-header`).removeAttribute("tabIndex")
      }
    },
    resetTabIndexHeader() {
      this.customOptions.forEach((element,index) => {
        document.querySelector(`.customizer-header-right-options-option--${element.name} button`).removeAttribute("tabIndex")
        document.querySelector(`.customizer-new-header__container-other-buttons`).removeAttribute("tabindex",0);
        document.querySelector(`.collapse-header`).removeAttribute("tabIndex");
      })
    },
    /**
     * Runs when Splash Page is opened (event emit)
     * @see beforeOpen() at SplashPage.vue
     */
    hideCollapsingHeader() {
      if (this.isSplashModalOpen && !this.isMobile && this.openHeader) {
        this.openHeaderHistory = this.openHeader;
        this.openHeader = false;
      }
    },
    /**
     * Runs when the Splash Page is closed (event emit)
     * @see exit() at SplashPage.vue
     */
    rollbackCollapsingHeader() {
      if (!this.isSplashModalOpen && !this.isMobile && this.openHeaderHistory) {
        this.openHeader = this.openHeaderHistory;
        this.openHeaderHistory = false;
      }
    }
  },
  created() {
    this.$eventBus.$on('changeExternalHeadersVisibility', this.changeExternalHeadersVisibility);
    this.$eventBus.$on('addToFavorites', this.handleFavorites);
    this.$eventBus.$on('parentAddToFavorites', this.handleFavorites);
    this.$eventBus.$on('tmall-save-design', this.handleTmallCTASaveDesign);
    this.$eventBus.$on('hideCollapsingHeader', this.hideCollapsingHeader);
    this.$eventBus.$on('rollbackCollapsingHeader', this.rollbackCollapsingHeader);
    this.$eventBus.$on('updateSwiperWidth', this.onSwiperUpdated);
    window.addEventListener('resize', this.onWindowResized);
  },
  mounted() {
    this.onWindowResized();
  },
  beforeUpdate() {
    if (!this.isMobile && this.configuration.enableCollapsableHeader) {
      this.$nextTick(this.handleHeaderWidth);
    }
  },
  beforeDestroy() {
    this.$eventBus.$off('changeExternalHeadersVisibility', this.changeExternalHeadersVisibility);
    this.$eventBus.$off('addToFavorites', this.handleFavorites);
    this.$eventBus.$off('parentAddToFavorites', this.handleFavorites);
    this.$eventBus.$off('tmall-save-design', this.handleTmallCTASaveDesign);
    this.$eventBus.$off('tmall-save-design', this.handleTmallCTASaveDesign);
    this.$eventBus.$off('hideCollapsingHeader', this.hideCollapsingHeader);
    this.$eventBus.$off('rollbackCollapsingHeader', this.rollbackCollapsingHeader);
    this.$eventBus.$off('updateSwiperWidth', this.onSwiperUpdated);
    window.removeEventListener('resize', this.onWindowResized);
  },
}
</script>
